import { ISchema } from '../@types'
import { buildSmallFallbackPaywall } from './web_small_fallback_paywall__b'

/**
 * web_small_fallback_paywall — variant C: variant B + a green→rose recolor of the fallback overlay.
 * `accent: 'rose'` makes PaywallSmallFallbackModal apply its scoped rose token remap; no global
 * styles, no shared-component changes.
 */
export default (schema: ISchema): ISchema => buildSmallFallbackPaywall(schema, 'rose')
